import { SdcToolbarMenuCtrl } from './sdc-toolbar-menu.controller';

export const SdcToolbarMenuComponent = {
  template: require('./sdc-toolbar-menu.html'),
  controller: SdcToolbarMenuCtrl,
  bindings: {
    currentUser: '<',
    currentState: '<',
  },
};
